export const env = {
  STAGE: import.meta.env.VITE_STAGE,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  GROWTH_BOOK_API_HOST: import.meta.env.VITE_GROWTH_BOOK_API_HOST,
  GROWTH_BOOK_CLIENT_KEY: import.meta.env.VITE_GROWTH_BOOK_CLIENT_KEY,
  CLASSTING_OIDC_URL: import.meta.env.VITE_CLASSTING_OIDC_URL,
  CLASSTING_OIDC_CLIENT_ID: import.meta.env.VITE_CLASSTING_OIDC_CLIENT_ID,
  CLASSTING_URL: import.meta.env.VITE_CLASSTING_URL,
  GELO_URL: import.meta.env.VITE_GELO_URL,
  AI_URL: import.meta.env.VITE_AI_URL,
  AD_VIEW_URL: import.meta.env.VITE_AD_VIEW_URL,
  ZOOM_CLIENT_ID: import.meta.env.VITE_ZOOM_CLIENT_ID,
  ZOOM_OAUTH_URL: import.meta.env.VITE_ZOOM_OAUTH_URL,
  LEARNING_VIEW_URL: import.meta.env.VITE_LEARNING_VIEW_URL,
  LEARNING_URL: import.meta.env.VITE_LEARNING_URL,
  INSIGHTS_URL: import.meta.env.VITE_INSIGHTS_URL,
  ORG_SERVICE_URL: import.meta.env.VITE_ORG_SERVICE_URL,
  GTM_CONTAINER_ID: import.meta.env.VITE_GTM_CONTAINER_ID,
  GTM_AUTH: import.meta.env.VITE_GTM_AUTH,
  GTM_ENV: import.meta.env.VITE_GTM_ENV,
  AD_NETWORK_ID: import.meta.env.VITE_AD_NETWORK_ID,
  LIGHTGALLERY_LICENSE_KEY: import.meta.env.VITE_LIGHTGALLERY_LICENSE_KEY,
  BACKEND_BASE_URL: import.meta.env.VITE_BACKEND_BASE_URL,
  GRAPHQL_BASE_URL: import.meta.env.VITE_GRAPHQL_BASE_URL,
  CLASSTALK_URL: import.meta.env.VITE_CLASSTALK_URL,
} as const;
